import { HeaderLink as e, HeaderNavLink as t } from "../base/HeaderLink.js";
import { MenuSlidingPanel as n } from "./MenuSlidingPanel.js";
import { useEffect as r, useRef as i, useState as a } from "react";
import { Button as o, Chevron as s, Close as c } from "@sprd/sprd-component-kit/v2";
import l from "clsx";
import { Fragment as u, jsx as d, jsxs as f } from "react/jsx-runtime";
import { Drawer as p } from "vaul";
import { createPortal as m } from "react-dom";
//#region src/components/Header/mobile/MobileCyoPortal.tsx
var h = "bottom-0! left-0! flex h-fit! w-full items-center justify-center p-4 pb-12";
function g({ navRef: e, isShown: t, item: s, closeLabel: c, linkComponent: p }) {
	let [g, v] = a(!1), y = i(!1), [b, x] = a(!1), S = () => {
		y.current = !0, v((e) => !e);
	};
	return r(() => {
		x(!!e.current);
	}, [e, t]), !b || !e.current ? null : m(/* @__PURE__ */ f(u, { children: [/* @__PURE__ */ d(n, {
		isShown: t,
		direction: "btt",
		className: l(h, "shadow-up z-10"),
		children: /* @__PURE__ */ d(o, {
			variant: "gradient",
			className: "w-full text-sm!",
			size: "l",
			onClick: S,
			children: s.label
		})
	}), y.current && /* @__PURE__ */ d(_, {
		item: s,
		open: g,
		onOpenChange: S,
		navRef: e,
		closeLabel: c,
		linkComponent: p
	})] }), e.current);
}
function _({ item: n, open: r, onOpenChange: i, navRef: a, closeLabel: l, linkComponent: u }) {
	return /* @__PURE__ */ d(p.Root, {
		open: r,
		onOpenChange: i,
		dismissible: !0,
		autoFocus: !0,
		container: a.current,
		children: /* @__PURE__ */ f(p.Portal, { children: [/* @__PURE__ */ d(p.Overlay, { className: "force-animation-150 absolute inset-0 z-50 bg-black-alpha-400" }), /* @__PURE__ */ f(p.Content, {
			className: "force-animation-150 absolute right-0 bottom-0 left-0 z-50 flex h-auto flex-col rounded-t-xl border bg-white p-4 pb-12 ease-in-out",
			children: [
				/* @__PURE__ */ f("div", {
					className: "flex min-h-11 items-center justify-between text-left",
					children: [/* @__PURE__ */ d(p.Title, {
						className: "bg-linear-to-r from-red-600 to-blue-700 bg-clip-text font-made text-lg text-transparent",
						children: n.headline
					}), /* @__PURE__ */ f(p.Close, {
						className: "cursor-pointer hover:text-neutral-800 focus-visible:shadow-[0_0_0_2px_var(--white)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus",
						children: [/* @__PURE__ */ d(c, {
							className: "size-6",
							"aria-hidden": !0
						}), /* @__PURE__ */ d("span", {
							className: "sr-only",
							children: l
						})]
					})]
				}),
				/* @__PURE__ */ d("ul", {
					className: "flex flex-col gap-2 pt-4 pb-12",
					children: (n.children ?? []).map((e) => e.link ? /* @__PURE__ */ d("li", { children: /* @__PURE__ */ f(t, {
						link: e.link,
						linkComponent: u,
						className: "flex w-full! items-center gap-3",
						children: [
							/* @__PURE__ */ d("div", {
								className: "size-16 shrink-0",
								children: e.image
							}),
							/* @__PURE__ */ f("div", {
								className: "flex flex-col",
								children: [/* @__PURE__ */ d("span", {
									className: "font-made",
									children: e.label
								}), /* @__PURE__ */ d("span", { children: e.subLabel })]
							}),
							/* @__PURE__ */ d(s, { className: "ml-auto flex size-6 shrink-0! -rotate-90" })
						]
					}) }, e.key) : null)
				}),
				n.link ? /* @__PURE__ */ d(o, {
					variant: "gradient",
					size: "l",
					className: "w-full!",
					asChild: !0,
					children: /* @__PURE__ */ d(e, {
						link: n.link,
						linkComponent: u,
						children: n.label
					})
				}) : null
			]
		})] })
	});
}
//#endregion
export { g as MobileCyoPortal };
